import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Footer = () => {
  const language = useSelector((state) => state.language);

  return (
    <footer className="bg-gray-900 text-white py-12" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Column 1 */}
          <div>
            <div className="text-2xl font-bold mb-4">RAQIB</div>
            <p className="text-gray-400">
              {language === "ar" 
                ? "رفيقك الطبي الذكي لإدارة الرعاية الصحية بكفاءة."
                : language === "fr"
                ? "Votre compagnon médical intelligent pour une gestion efficace des soins de santé."
                : "Your intelligent medical companion for efficient healthcare management."}
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              {language === "ar" ? "المنتج" : language === "fr" ? "Produit" : "Product"}
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/features" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الميزات" : language === "fr" ? "Fonctionnalités" : "Features"}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "التسعير" : language === "fr" ? "Tarification" : "Pricing"}
                </Link>
              </li>
              <li>
                <a href="https://app.raqibapp.com/login" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "عرض توضيحي" : language === "fr" ? "Démo" : "Demo"}
                </a>
              </li>
              <li>
                <button className="hover:text-teal-300 transition-colors bg-none border-none p-0 cursor-pointer text-left">
                  {language === "ar" ? "التحديثات" : language === "fr" ? "Mises à jour" : "Updates"}
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              {language === "ar" ? "الشركة" : language === "fr" ? "Entreprise" : "Company"}
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/about" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "حول" : language === "fr" ? "À propos" : "About"}
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الوظائف" : language === "fr" ? "Carrières" : "Careers"}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "المدونة" : language === "fr" ? "Blog" : "Blog"}
                </Link>
              </li>
              <li>
                <Link to="/press" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الأخبار" : language === "fr" ? "Presse" : "Press"}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              {language === "ar" ? "القانونية" : language === "fr" ? "Légal" : "Legal"}
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/privacy" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الخصوصية" : language === "fr" ? "Confidentialité" : "Privacy"}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الشروط" : language === "fr" ? "Conditions" : "Terms"}
                </Link>
              </li>
              <li>
                <Link to="/hipaa" className="hover:text-teal-300 transition-colors">
                  HIPAA
                </Link>
              </li>
              <li>
                <Link to="/security" className="hover:text-teal-300 transition-colors">
                  {language === "ar" ? "الأمان" : language === "fr" ? "Sécurité" : "Security"}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} RAQIB. {language === "ar" ? "جميع الحقوق محفوظة." : language === "fr" ? "Tous droits réservés." : "All rights reserved."}
          </div>
          <div className="flex space-x-6">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-300 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"></path>
              </svg>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-300 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
              </svg>
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-300 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.167 6.839 9.49.5.09.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.34-3.369-1.34-.454-1.156-1.11-1.463-1.11-1.463-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.025A9.564 9.564 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.293 2.747-1.025 2.747-1.025.546 1.377.202 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"></path>
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-300 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
